import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { asyncMessagesLoader } from './asyncMessagesLoader';
export class TranslationsState {
  constructor(_params) {
    _defineProperty(this, "i18n", void 0);
    _defineProperty(this, "_initPromise", void 0);
    _defineProperty(this, "_ready", void 0);
    _defineProperty(this, "translate", (key, params) => this.i18n.t(key, params));
    _defineProperty(this, "getTranslateFn", async () => {
      await this.getInitPromise();
      return this.translate;
    });
    this.i18n = _params.createI18n({
      asyncMessagesLoader,
      disableAutoInit: true
    });
    this._initPromise = new Promise(async resolve => {
      let failedLoading = false;
      const onFailedLoading = (lng, _ns, err) => {
        // reject only when fallback lang (en) fails to load
        if (lng !== 'en') {
          return;
        }
        this.i18n.off('failedLoading', onFailedLoading);
        failedLoading = true;
        resolve(err);
      };
      this.i18n.on('failedLoading', onFailedLoading);
      try {
        await this.i18n.init();
        if (failedLoading) {
          return;
        }
        resolve(null);
        this._ready = true;
      } catch (e) {
        resolve(e);
      }
    });
  }
  async getInitPromise() {
    const error = await this._initPromise;
    if (error) {
      throw error;
    }
  }
}
//# sourceMappingURL=TranslationsState.js.map